<div class="share-content-editor row">
    <div class="modal-header visible-xs">
        <div class="modal-heading">{{ 'flipto.account.ShareOn' | translate: sharing()?.network }}</div>
    </div>

    <div class="ft-col-66">
        <div class="share-content-preview">
            <div class="share-author">{{ property()?.Name }}</div>
            <div
                [class]="{
                    'ft-field-error': messageVisible() && (!messageValid() || messagePristine()),
                    'field-error': messageVisible() && !messageValid() && !messagePristine()
                }"
            >
                @if (!isInstagram(sharing()?.network) && !isFacebook(sharing()?.network)) {
                    <textarea
                        class="share-message"
                        [attr.placeholder]="'flipto.account.AddYourMessage' | translate"
                        [attr.maxlength]="shareMessageLimit()"
                        name="message"
                        [value]="sharing()?.message || ''"
                        (input)="onMessageInput($any($event.target).value)"
                    ></textarea>
                }
            </div>
            <div class="share-photo-preview" [ngClass]="previewClasses">
                <div class="share-image-blur" [ftBackgroundImage]="sharing()?.backgroundPhoto"></div>
                <div class="share-image" [ftBackgroundImage]="sharing()?.backgroundPhoto">
                    <div class="photo-matte"></div>
                    <div class="photo-info-shell">
                        <div class="photo-info-content">
                            <div class="photo-info">
                                <ft-image ft-profile-photo always-visible [class.ng-hide]="!sharing()?.isShowProfilePic">
                                    <div class="ft-image-div" [ftBackgroundImage]="guest()?.profileImageUrl"></div>
                                </ft-image>
                                <div class="guest-name" [class.ng-hide]="!sharing()?.isShowGuestName">
                                    {{ guest() | fullName: true }}
                                </div>
                                @if (hasPositiveQuote() && !isLinkedin(sharing()?.network) && !isHotelRatedNegativeQuote()) {
                                    <div
                                        class="guest-quote"
                                        [class.ng-hide]="!sharing()?.isShowGuestQuote"
                                    >
                                        &ldquo;{{ guest()?.poststay?.quote?.notesPositive | truncate: quoteSize():true }}&rdquo;
                                    </div>
                                }
                                @if (hasPhoto() && !isLinkedin(sharing()?.network) && !isHotelRatedNegativeCaption()) {
                                    <div
                                        class="photo-caption"
                                        [class.ng-hide]="!sharing()?.isShowPhotoCaption || !sharing()?.backgroundIsGuestPhoto"
                                    >
                                        {{ guest()?.poststay?.photo?.caption | truncate: captionSize():true }}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ft-col-33">
        <div class="modal-header hidden-xs">
            <div class="modal-heading">{{ 'flipto.account.ShareOn' | translate: sharing()?.network }}</div>
        </div>
        <div class="editor-options">
            <div class="editor-option">
                <label>{{ 'flipto.account.BackgroundPhoto' | translate }}</label>
                <div class="ft-dropdown opens-center" [class.active]="dropdownOpen()" (click)="dropdownOpen.set(!dropdownOpen())">
                    <a class="ft-btn ft-btn-plus-1 ft-btn-outline-light ft-dropdown-toggle">
                        @if (sharing()?.backgroundIsGuestPhoto) {
                            <span>{{ 'flipto.account.GuestPhoto' | translate }}</span>
                        }
                        @if (!sharing()?.backgroundIsGuestPhoto) {
                            <span>{{ 'flipto.account.HotelPhoto' | translate }}</span>
                        }
                        <span class="caret"></span>
                    </a>
                    <ul class="ft-dropdown-menu">
                        @if (hasPhoto()) {
                            <li
                                class="photo-option"
                                [class.active]="sharing()?.backgroundIsGuestPhoto"
                                [ftBackgroundImage]="azurePhoto(guest()?.poststay?.photo, 'small')"
                            >
                                <a (click)="sharing().backgroundIsGuestPhoto = true">{{ 'flipto.account.GuestPhoto' | translate }}</a>
                            </li>
                        }
                        <li
                            class="photo-option"
                            [class.active]="!sharing()?.backgroundIsGuestPhoto"
                            [ftBackgroundImage]="property()?.BackgroundImageUrl"
                        >
                            <a (click)="sharing().backgroundIsGuestPhoto = false">{{ 'flipto.account.HotelPhoto' | translate }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <hr />
            <div class="editor-option">
                <label>{{ 'flipto.account.GuestProfilePic' | translate }}</label>
                <ft-switch>
                    <div class="ft-switch">
                        <input
                            class="ft-switch-toggle"
                            type="checkbox"
                            [checked]="!!sharing()?.isShowProfilePic"
                            (change)="sharing().isShowProfilePic = $any($event.target).checked"
                        />
                        <label></label>
                    </div>
                </ft-switch>
            </div>
            <div class="editor-option">
                <hr />
                <label>{{ 'flipto.account.GuestName' | translate }}</label>
                <ft-switch>
                    <div class="ft-switch">
                        <input
                            class="ft-switch-toggle"
                            type="checkbox"
                            [checked]="!!sharing()?.isShowGuestName"
                            (change)="sharing().isShowGuestName = $any($event.target).checked"
                        />
                        <label></label>
                    </div>
                </ft-switch>
            </div>
            @if (!isLinkedin(sharing()?.network) && hasPositiveQuote() && !isHotelRatedNegativeQuote()) {
                <div class="editor-option">
                    <hr />
                    <label>{{ 'flipto.account.sections.platform.photoAdvocacy.Quote' | translate }}</label>
                    <ft-switch>
                        <div class="ft-switch">
                            <input
                                class="ft-switch-toggle"
                                type="checkbox"
                                [checked]="!!sharing()?.isShowGuestQuote"
                                (change)="sharing().isShowGuestQuote = $any($event.target).checked"
                            />
                            <label></label>
                        </div>
                    </ft-switch>
                </div>
            }
            @if (guest()?.poststay?.photo && sharing()?.backgroundIsGuestPhoto && !isLinkedin(sharing()?.network) && hasCaption() && !isHotelRatedNegativeCaption()) {
                <div class="editor-option">
                    <hr />
                    <label>{{ 'flipto.account.PhotoCaption' | translate }}</label>
                    <ft-switch>
                        <div class="ft-switch">
                            <input
                                class="ft-switch-toggle"
                                type="checkbox"
                                [checked]="!!sharing()?.isShowPhotoCaption"
                                (change)="sharing().isShowPhotoCaption = $any($event.target).checked"
                            />
                            <label></label>
                        </div>
                    </ft-switch>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button
                type="button"
                class="ft-btn ft-btn-plus-1 ft-btn-default btn-confirm"
                [disabled]="isPreviewDisabled()"
                (click)="previewPost.emit()"
            >
                {{ 'flipto.account.sections.platform.photoAdvocacy.PreviewPost' | translate }}
            </button>
            <button
                type="button"
                class="ft-btn ft-btn-plus-1 ft-btn-outline-light btn-cancel"
                (click)="cancelClicked.emit()"
            >
                {{ 'flipto.account.Cancel' | translate }}
            </button>
        </div>
    </div>
</div>
